import api from "../helpers/interceptor";

export const getCareerList = async (payload) =>
  await api.get(
    `/getCareers?page=${payload.page}&limit=${payload.limit}&search_key=${payload.search_key}`
  );
export const delCareerList = async (payload) =>
  await api.put(`/deleteCareer`, payload);

export const addCareerData = async (payload) =>
  await api.post(`/addCareer`, payload);
export const getCareerDetails = async (payload) =>
  await api.get(
    `/getCareerDetails?career_id=${payload.id}&type=${payload.type}`
  );
export const editCareerDetails = async (payload) =>
  await api.put(`/editCareerDetails`, payload);

export const getProfessions = async (payload) =>
  await api.get(`/getCareerProfessions?cluster_id=${payload}`);
